import React from 'react';
import List from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import { Link, useLocation } from 'react-router-dom';
import HomeIcon from '@material-ui/icons/Home';
import NotificationsIcon from '@material-ui/icons/Notifications';
import LanguageIcon from '@material-ui/icons/Language';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import GetAppIcon from '@material-ui/icons/GetApp';
import SpellcheckIcon from '@material-ui/icons/Spellcheck';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { WithTooltip } from 'components/WithTooltip';
import BusinessIcon from '@material-ui/icons/Business';
import DvrOutlinedIcon from '@material-ui/icons/DvrOutlined';
import GavelIcon from '@material-ui/icons/Gavel';

interface MenuItem {
  title: string;
  path: string;
  icon: (className: string) => JSX.Element;
  disabled?: boolean;
}

export const MAIN_MENU: MenuItem[] = [
  {
    title: 'Accounts Overview',
    path: '/accounts-overview',
    icon: (className) => <DvrOutlinedIcon className={className} data-auto-id="notification-icon" />
  },
  {
    title: 'Insights',
    path: '/insights',
    icon: (className) => <EqualizerIcon className={className} data-auto-id="equalizer-icon" />
  },
  {
    title: 'Publishers',
    path: '/publishers',
    icon: (className) => <BusinessIcon className={className} data-auto-id="notification-icon" />
  },
  {
    title: 'Performance Rules',
    path: '/rules',
    icon: (className) => <GavelIcon className={className} data-auto-id="notification-icon" />
  },
  {
    title: 'Lead Forms Library',
    path: '/lead-forms/library',
    icon: (className) => <LibraryBooksIcon className={className} data-auto-id="notification-icon" />
  },
  {
    title: 'Pixels',
    path: '/pixels',
    icon: (className) => <LanguageIcon className={className} data-auto-id="language-icon" />
  },
  {
    title: 'Facebook Imports',
    path: '/facebook_imports',
    icon: (className) => <GetAppIcon className={className} data-auto-id="get-app-icon" />
  },

  {
    title: 'Experiments',
    path: '/experiments',
    icon: (className) => <SpellcheckIcon className={className} data-auto-id="assessment-icon" />
  },
  {
    title: 'Alerts',
    path: '/alerts',
    icon: (className) => <NotificationsIcon className={className} data-auto-id="notification-icon" />
  }
];

export const useStyles = makeStyles((theme) => ({
  active: {
    color: theme.palette.primary.main
  }
}));

interface Props {
  collapsed: boolean;
}

export const AppLeftMenu: React.FC<Props> = ({ collapsed }: Props) => {
  const classes = useStyles();
  const location = useLocation();
  const isActive = (pathname: string) => location.pathname.indexOf(pathname) === 0;
  const isHomeLocation = location.pathname === '/';
  return (
    <>
      <List>
        <ListItem button component={Link} to="/" className={clsx(isHomeLocation && classes.active)}>
          <ListItemIcon>
            <HomeIcon className={clsx(isHomeLocation && classes.active)} data-auto-id="home-icon" />
          </ListItemIcon>
          <ListItemText primary="Home" />
        </ListItem>
      </List>
      <Divider />
      <List>
        {MAIN_MENU.map((menu) => (
          <WithTooltip title={menu.title} placement="right" enabled={collapsed} key={menu.path}>
            <ListItem
              button
              component={Link}
              to={menu.path}
              className={clsx(isActive(menu.path) && classes.active)}
              disabled={menu.disabled}
            >
              <ListItemIcon>{menu.icon(isActive(menu.path) ? classes.active : '')}</ListItemIcon>
              <ListItemText primary={menu.title} />
            </ListItem>
          </WithTooltip>
        ))}
      </List>
    </>
  );
};
